// CourseTracker.js
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const CourseTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes('/course')) {
      localStorage.removeItem('cameFromCourse');
    }
  }, [location.pathname]);

  return null;
};

export default CourseTracker;
